import ivclass from '@invideoio/web-shared/Modules/IVClass';

interface CardSubTitleProps {
  subTitle?: string;
}

function CardSubTitle({ subTitle }: CardSubTitleProps) {
  return (
    <div
      className={ivclass(
        'iv-text-black-50',
        'xl:iv-text-heading-4xs iv-text-body-4xl sm:iv-text-body-xl',
        'xl:iv-m-heading-4xs iv-m-body-4xl sm:iv-m-body-xl',
        'iv-font-semibold',
      )}
    >
      {subTitle}
    </div>
  );
}

export default CardSubTitle;
